<template>

    <div class="InsertRecipe col-12" :class="divClasses">
        <Multiselect
            v-model="Recipe"
            placeholder="Insert A Recipe"
            :options="Recipes"
            valueProp="id"
            label="name"
            noOptionsText="Type to search for recipes"
            noResultsText="Looks like you are out of options."
            :searchable="true"
            @search-change="searchRecipes"
            @select="AddRecipe"
            :key="'RecipesKey'+NewRecipeOptionKey"
            class="selectRecipe"
            :class="selectClasses"
        />
    </div>

</template>
<script>
import Multiselect from '@vueform/multiselect';

export default {
    name: 'RecipeInsert',
    components: {
        Multiselect
    },
    props: {
        divClasses: String,
        selectClasses: {
            type: String,
            default: 'col-6'
        }
    },
    data() {
        return {
            Recipe: '',
            NewRecipeOptionKey: 0
        };
    },
    computed: {
        Recipes() {
            return this.$store.getters.Recipes_GetAll();
        }
    },
    methods: {
        searchRecipes(query) {
            if (query.length === 0)
            {
                this.$store.dispatch('Recipes_UpdateAll', query);
                this.NewRecipeOptionKey += 1;
            }
            if (query.length > 2) { this.$store.dispatch('Recipes_Search', query); }
        },
        AddRecipe(RecipeID) {
            let Recipe = this.Recipes.find(Rec => Rec.id === RecipeID);
            let Link = '<a href="'+this.$store.state.Site.Domain+'/Recipes/'+RecipeID+'" data-recipe="'+RecipeID+'">'+Recipe.name+'</a>';
            this.$emit('InsertRecipe', Link);
            this.Recipe = null;
        }
    }
};
</script>
<style lang="scss">
.InsertRecipe {
    .selectRecipe {
        float: right;
        min-height: 30px;
        padding: 0;
    }
}
</style>
